import axios from '../axios'

// 分页查询
export const getLocaleId = () => {
  return axios({
    url: '/sysOptions/getLocaleId',
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/sysOption.js